/**
 * @Description: 草稿库路由
 * @author zhaijiayu
 * @date 2021/8/17
*/

import DraftList from '../../../pages/scriptLibrary/draft';

const list = [
    {
        path: '/draft',
        component: DraftList,
        name: 'draft'
    },
]
export default list